<template>
  <div id="AdminUserPage">
    <section class="section">
      <div class="container">
        <h1 class="title is-primary" style="color: #00AEEF; font-weight: 100;">
          {{ $t("users.title") }}
        </h1>
        <admin-user-table />
      </div>
    </section>
  </div>
</template>

<script>
import AdminUserTable from "@/components/tables/AdminUserTable.vue";

export default {
  name: "AdminUserPage",
  components: {
    AdminUserTable
  }
};
</script>
